import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-book-1",
  "use": "icon-si-glyph-book-1-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-book-1\" id=\"icon-si-glyph-book-1\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>90</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(0.000000, 2.000000)\" fill=\"#434343\">\n            <path d=\"M8,1.00708203 C4.691,-0.555917969 2.11,0.319193355 0,1.60919336 L0,11.934082 C2.105,10.636082 5.248,9.57019336 8,10.9881934 L8,1.00708203 Z\" class=\"si-glyph-fill\" />\n            <path d=\"M8,11.0016033 C11.629,9.53860328 13.919,10.6494531 16,11.9394531 L16,1.62060328 C13.919,0.335603278 11.882,-0.817396722 8,0.775603278 L8,11.0016033 Z\" class=\"si-glyph-fill\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-book-1.svg
// module id = q6Rm
// module chunks = 62